import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { ItemComponentModels } from './MasterItemsModels';

export const addItemComponent = createAsyncThunk(
  'ItemComponent/addItemComponent',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AddItemComponent', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getItemComponentsByItemId = createAsyncThunk(
  'ItemComponent/getItemComponentsByItemId',
  async (ItemId: string, { rejectWithValue }) => {
    try {
      //
      const { data } = await ntxAPI.post(`Inv/GetItemComponentsByItemId?ItemId=${ItemId}`);
      if (data.succeeded === true) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteItemComponentCommand = createAsyncThunk(
  'ItemComponent/deleteItemComponentCommand',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/DeleteItemComponentCommand', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ItemComponenListByItem: ItemComponentModels[];
  loading: boolean;
  error: any | null;
} = {
  ItemComponenListByItem: [],
  loading: false,
  error: null
};

const ItemComponentSlice = createSlice({
  name: 'ItemComponent',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getItemComponentsByItemId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getItemComponentsByItemId.fulfilled, (state, action: PayloadAction<ItemComponentModels[]>) => {
        state.loading = false;
        state.ItemComponenListByItem = action.payload;
      })
      .addCase(getItemComponentsByItemId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default ItemComponentSlice.reducer;
